export const investorType = {
  INDIVIDUAL: 1,
  CORPORATE: 2,
};
